export interface IMessageBuilderSlackStrategy {
  buildMessage(acao: string): string;
}

export const MessageBuilderSlackDi = Symbol("MessageBuilderSlackDi");
